import { gql } from "@apollo/client";

export const GET_EXTERNAL_USERS = gql`
  query getExternalUsers($page: Int, $limit: Int) {
    getExternalUsers(page: $page, limit: $limit) {
      success
      message
      data {
        id
        name
        email
        role_id
        role_name
        access_from
        access_till
        is_active
        is_access_active
        granted_by_email
        created_at
        updated_at
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const CREATE_EXTERNAL_USER = gql`
  mutation createExternalUser($input: CreateExternalUserInput!) {
    createExternalUser(input: $input) {
      success
      message
      data {
        id
        name
        email
        role_id
        role_name
        access_from
        access_till
        is_active
        is_access_active
        granted_by_email
        created_at
        updated_at
      }
    }
  }
`;

export const UPDATE_EXTERNAL_USER_ACCESS = gql`
  mutation updateExternalUserAccess($input: UpdateExternalUserAccessInput!) {
    updateExternalUserAccess(input: $input) {
      success
      message
      data {
        id
        name
        email
        role_id
        role_name
        access_from
        access_till
        is_active
        is_access_active
        granted_by_email
        created_at
        updated_at
      }
    }
  }
`;

